const DonationStatus = {
    Cancelled: 1,
    Expired: 2,
    Paid: 3,
    Pending: 4
};

export default DonationStatus;
